export interface ProfileDocumentsInterface {
	cvs: any[],
}

export class ProfileDocumentsClass implements ProfileDocumentsInterface {
	cvs = [];
}
